import { Badge } from '@personachat/ui';
import { useQuery } from '@tanstack/react-query';
import type { ReactNode } from 'react';
import { NavLink } from 'react-router-dom';

import { api } from '../../api/client';
import { lire } from '../../api/call';
import { PageHeader } from '../../pages/PageHeader';

/** Vue d'ensemble des ventes : mode Stripe et webhooks en échec (onglet Paiements). */
export function useVentes() {
  return useQuery({
    queryKey: ['ventes', 'vue'],
    queryFn: async () => (await lire(api.GET('/api/admin/billing/overview'))).data,
    staleTime: 60_000,
  });
}

const ONGLETS = [
  { to: '/ventes/packs', label: 'Packs (achat ponctuel)' },
  { to: '/ventes/abonnements', label: 'Abonnements (récurrent)' },
  { to: '/ventes/abonnees', label: 'Abonnées' },
  { to: '/ventes/paiements', label: 'Paiements' },
];

/**
 * Ventes (cahier des charges §7.8) : quatre onglets aux noms explicites, une
 * URL chacun ; le mode Stripe (test ou réel) est toujours visible.
 */
export function VentesEntete({ lead, actions }: { lead: ReactNode; actions?: ReactNode }) {
  const vue = useVentes();
  const v = vue.data;
  const echecs = v?.webhooksEnEchec7j ?? 0;
  return (
    <>
      <PageHeader
        title="Ventes"
        lead={
          <>
            {lead}{' '}
            {v &&
              (v.stripeMode === 'live' ? (
                <Badge tone="success">Stripe : paiements réels</Badge>
              ) : v.stripeMode === 'test' ? (
                <Badge tone="gold">Stripe : mode test</Badge>
              ) : (
                <Badge tone="danger">Stripe non configuré</Badge>
              ))}
          </>
        }
        actions={actions}
      />
      <nav className="tabs" aria-label="Ventes">
        {ONGLETS.map((o) => (
          <NavLink key={o.to} to={o.to} className={({ isActive }) => (isActive ? 'tabs__tab tabs__tab--active' : 'tabs__tab')}>
            {o.label}
            {o.to === '/ventes/paiements' && echecs > 0 && (
              <span className="tabs__count tabs__count--danger" title="Webhooks Stripe en échec sur 7 jours">
                {echecs}
              </span>
            )}
          </NavLink>
        ))}
      </nav>
    </>
  );
}
